import React, { useState,} from "react";

import AppBar from '@mui/material/AppBar'
import color from "../theme/color";
import logout from "../assets/logout.png";
import {Customer} from '../screens/customers'
import useClasses from "../common/UseClasses";
import { Box, Button, IconButton, Menu, MenuItem, Theme, Toolbar, Typography, useTheme } from "@mui/material";
import { AccountCircle, ArrowDropDown, ArrowDropDownCircle, ArrowDropDownCircleOutlined, ThreeDRotation } from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const useStyles = (theme: Theme) => ({
    grow: {},
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.common.white,
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
        width: "auto",
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputRoot: {
      color: "inherit",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "20ch",
      },
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 300,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    }
  })

type DashboardProps = {
  onLogout: () => void;
  onProjectChange: (name: string) => void;
  projectName: string;
  customers: Customer[]
};

const ApplicationBar: React.FC<DashboardProps> = ({
  onLogout,
  projectName,
  onProjectChange,
  customers,
  ...rest
}) => {
  const [tokenLoaded, setTokenLoaded] = useState();
  const theme= useTheme()
  // const classes = useStyles();
  const classes: any = useClasses(useStyles(theme));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = React.useState<null | HTMLElement>(null);
  const [age, setAge] = React.useState("");

  const [anchorElProj, setAnchorElProj] = React.useState(null);
  const openProj = Boolean(anchorElProj);

  const handleClick = (event: any) => {
    setAnchorElProj(event.currentTarget);
  };
  const handleProjClose = () => {
    setAnchorElProj(null);
  };

  const onProjectMenuClose = (event: any, name: string) => {
    console.log("event :::", event);
    onProjectChange(name);
    setAnchorElProj(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: any) => {
    setAge(event.target.value);
  };

  const open = Boolean(anchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const onLogoutClick = () => {
    setAnchorEl(null);
    // setLogout();
  };

  //console.log("customers", customers);

  const menuId = "primary-search-account-menu";
  const mobileMenuId = "primary-search-account-menu-mobile";
  return (
    <Box sx={classes.grow}>
      <AppBar position="static" sx={{backgroundColor:color.primaryBlue}}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {/*<IconButton*/}
            {/*  edge="start"*/}
            {/*  className={classes.menuButton}*/}
            {/*  color="inherit"*/}
            {/*  aria-label="open drawer"*/}
            {/*>*/}
            {/*  <MenuIcon />*/}
            {/*</IconButton>*/}
            <Typography sx={classes.title} variant="h6" noWrap>
              Dashboard
            </Typography>

            <Button
              sx={{
                backgroundColor: "transparent",
                marginLeft: 5,
                minWidth: 230,
                fontSize: 15,
                color:"white",
                fontFamily: "Roboto",
                fontWeight: 500,
                lineHeight: 1.6,
                letterSpacing: "0.0050em",
              }}
              onClick={handleClick}
            >
              {projectName}
              <ArrowDropDown
                style={{ height: 30, width: 30, marginLeft: 10 }}
              />
            </Button>

            <Menu
              id="fade-menu"
              anchorEl={anchorElProj}
              keepMounted
              open={openProj}
              onClose={handleProjClose}
              // TransitionComponent={Fade}
            >
              
              {
               
                customers.map((customer, index)  => {
                  return( <MenuItem key={index}
                    onClick={(event) =>
                      onProjectMenuClose(event, customer.name)
                    }
                  >
                    {customer.name}
                  </MenuItem>)
                 
                })
              }
             
            </Menu>
          </div>

          <Box sx={classes.sectionDesktop}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle sx={{
                color:grey[50]
              }}/>
            </IconButton>
          </Box>
          <Box sx={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <ThreeDRotation />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {/*{renderMobileMenu}*/}
      {/*{renderMenu}*/}

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={onLogout}
          sx={{
            fontSize: 16,
            fontFamily: "Poppins",
            letterSpacing: 0.75,
            fontWeight: 600,
            color: "red",
          }}
        >
          <img
            src={logout}
            style={{
              height: 30,
              objectFit: "contain",
              marginRight: 10,
            }}
          />
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ApplicationBar;
